var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M677.55 396.48 512 562.03 346.45 396.48c-16.64-16.64-43.52-16.64-60.16 0-16.64 16.64-16.64 43.52 0 60.16l195.84 195.84c16.64 16.64 43.52 16.64 60.16 0l195.84-195.84c16.64-16.64 16.64-43.52 0-60.16-16.64-16.21-43.95-16.64-60.59 0Z"
  })));
};
export default SvgDown;